import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import english from './main.json'

import french from './fr/main.json'
import italian from './it/main.json'
import german from './de/main.json'

i18next
	.use(initReactI18next)
	.init({
		lng: 'German',
		debug: false,
		fallbackLng: process.env.NODE_ENV === 'production' ? 'German' : null,
		resources: {
			German: { translation: german, locale: 'de' },
			French: { translation: french, locale: 'fr' },
			Italian: { translation: italian, locale: 'it' },
			English: { translation: english, locale: 'en' }
		},
		interpolation: {
			escapeValue: false // not needed for react as it escapes by default
		}
	})
